import Vue from 'vue'
import App from './App.vue'
/*import SocketIO from 'socket.io-client'
import VueSocketIO from 'vue-socket.io'*/
import axios from "axios";
import './assets/common.less'
import dataV from '@jiaminghi/data-view'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'

Vue.config.productionTip = false

Vue.use(dataV)
Vue.use(ElementUI)

/*const options = {}
Vue.use(new VueSocketIO({
  debug: true, // 调试模式，开启后将在命令台输出蓝色的相关信息
  connection: SocketIO('http://127.0.0.1:48080/infra/ws', options), // 这里的url仅需配置到端口号，我没有配options
  vuex: {
    actionPrefix: 'SOCKET_',
    mutationPrefix: 'SOCKET_'
  }
}))*/

Vue.prototype.$http = axios

new Vue({
  render: h => h(App)
}).$mount('#app')
